"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _Profile = require("../../provider/Profile");

var _Judgements = require("../../provider/Judgements");

var _Box = _interopRequireDefault(require("@material-ui/core/Box"));

var _Divider = _interopRequireDefault(require("@material-ui/core/Divider"));

var _Chip = _interopRequireDefault(require("@material-ui/core/Chip"));

var _reactI18next = require("react-i18next");

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _Button = _interopRequireDefault(require("@jobmatchme/ui/es/components/styleguide/Button"));

var _Headline = _interopRequireDefault(require("../Headline"));

var _ProfileNotActive = _interopRequireDefault(require("../Matches/ProfileNotActive"));

var _Authentication = require("../../provider/Authentication");

var _FadeIn = require("@jobmatchme/ui/es/components/FadeIn");

var _moment = _interopRequireDefault(require("moment"));

var _Skeleton = _interopRequireDefault(require("@material-ui/lab/Skeleton"));

var _styleModule = _interopRequireDefault(require("./style.module.scss"));

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Skeleton = function Skeleton(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Skeleton.default, (0, _extends2.default)({
    className: _styleModule.default.skeleton
  }, props));
};

var LikedMatches = function LikedMatches(_ref) {
  var switchTab = _ref.switchTab;
  var profileContext = (0, _react.useContext)(_Profile.ProfileContext);

  var _useContext = (0, _react.useContext)(_Judgements.JudgementsContext),
      userLikesWithMatchData = _useContext.userLikesWithMatchData;

  var _useContext2 = (0, _react.useContext)(_Judgements.JudgementsActionsContext),
      hydrateJoboffers = _useContext2.hydrateJoboffers;

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  var _useContext3 = (0, _react.useContext)(_Authentication.AuthenticationContext),
      user = _useContext3.user;

  var translateNs = 'pc-matching:LikedMatches';
  (0, _react.useEffect)(function () {
    hydrateJoboffers();
  }, [hydrateJoboffers]);

  var DeactivatedProfile = function DeactivatedProfile() {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
        mt: 2,
        children: t("".concat(translateNs, ".profileDeactivated"))
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
        className: _styleModule.default.btnWrapper,
        textAlign: "center",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ProfileNotActive.default, {
          onlyButton: true,
          user: user
        })
      })]
    });
  };

  var NoLikes = function NoLikes() {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
        mt: 2,
        children: t("".concat(translateNs, ".noLikes"))
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
        className: _styleModule.default.btnWrapper,
        textAlign: "center",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
          extraBold: true,
          round: true,
          variant: "contained",
          color: "primary",
          align: "center",
          texttransform: "none",
          fullWidth: true,
          flat: true,
          onClick: function onClick() {
            return switchTab('search');
          },
          children: t("".concat(translateNs, ".backToSearch"))
        })
      })]
    });
  };

  var getFormatedDate = function getFormatedDate(timestamp) {
    return (0, _moment.default)(timestamp).format('DD.MM.YY');
  };

  var List = function List() {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
      className: "".concat(_styleModule.default.list, " ").concat(!profileContext.active ? _styleModule.default.opacity : ''),
      children: userLikesWithMatchData.map(function (m, index) {
        var _m$minimalJoboffer, _m$minimalJoboffer2, _m$minimalJoboffer2$l;

        return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Divider.default, {}), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Box.default, {
            className: _styleModule.default.item,
            children: [m.matchStatus && m.matchStatus.toLowerCase() !== 'in_progress' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Chip.default, {
              size: "small",
              label: t("".concat(translateNs, ".").concat(m.matchStatus.toLowerCase())),
              className: "".concat(_styleModule.default[m.matchStatus.toLowerCase()], " ").concat(_styleModule.default.chip)
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
              component: "span",
              className: _styleModule.default.date,
              children: getFormatedDate(m.matchTimestamp)
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Headline.default, {
              variant: "h6",
              component: "h6",
              text: ((_m$minimalJoboffer = m.minimalJoboffer) === null || _m$minimalJoboffer === void 0 ? void 0 : _m$minimalJoboffer.displayName) || /*#__PURE__*/(0, _jsxRuntime.jsx)(Skeleton, {
                width: "80%",
                variant: "text"
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
                component: "span",
                children: ((_m$minimalJoboffer2 = m.minimalJoboffer) === null || _m$minimalJoboffer2 === void 0 ? void 0 : (_m$minimalJoboffer2$l = _m$minimalJoboffer2.location) === null || _m$minimalJoboffer2$l === void 0 ? void 0 : _m$minimalJoboffer2$l.name) || /*#__PURE__*/(0, _jsxRuntime.jsx)(Skeleton, {
                  width: "40%",
                  variant: "text"
                })
              })
            })]
          })]
        }, "like".concat(index));
      })
    });
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_FadeIn.SimpleFadeIn, {
    transition: 0.5,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Box.default, {
      component: "div",
      className: _styleModule.default.layout,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Headline.default, {
        className: _styleModule.default.headline,
        variant: "h1",
        component: "h1",
        text: t("".concat(translateNs, ".headline"))
      }), !profileContext.active && /*#__PURE__*/(0, _jsxRuntime.jsx)(DeactivatedProfile, {}), userLikesWithMatchData.length === 0 ? /*#__PURE__*/(0, _jsxRuntime.jsx)(NoLikes, {}) : /*#__PURE__*/(0, _jsxRuntime.jsx)(List, {})]
    })
  });
};

var _default = LikedMatches;
exports.default = _default;